import React, { useContext, useEffect, useState } from 'react';
import { SiteContext } from '../../../context/SiteContext';
import { CarInsuranceApi } from '../../../api/CarInsuranceApi';
import { ButtonBack } from '../../common/Button/ButtonBack';
import { ButtonContinue } from '../../common/Button/ButtonContinue';
import {
  AdditionalDriverDropDowns,
  ClaimError,
  DatalistOption,
  DrivingConvictionError,
  DrivingHistoryApiResponseModel,
  InsuranceJourneyContext,
  KeyValuePair,
  MedicalConditionError,
  SelectOpt
} from '../../common/CommonTypes';
import SelectInput, {
  SelectInputHelper
} from '../../common/SelectInput/SelectInput';
import {
  populateDatalist,
  populateSelectOptions,
  renderRadioOptions,
  setCountryCode,
  getInsuranceJourneyMinMaxDob,
  isValidName
} from '../../common/HelperMethods';
import { useNavigate, useOutletContext } from 'react-router-dom';
import TextInput from '../../common/TextInput/TextInput';
import { CommonValidation } from '../../common/CommonValidation/commonValidation';
import DateSelector from '../../common/DateSelector/DateSelector';
import GenderSelection from '../../common/GenderSelection/GenderSelection';
import Checkbox from '../../common/Checkbox/Checkbox';
import SearchTextInput from '../../common/SerachTextInput/SearchTextInput';
import Tooltip from '@mui/material/Tooltip';
import RadioSelection from '../../common/Product/RadioSelection';
import MedicalConditions from '../../common/MedicalConditions/MedicalConditions';
import RadioOptions from '../../common/RadioOptions/RadioOptions';
import DrivingConvictions from '../../common/DrivingConvictions/DrivingConvictions';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { t } from 'i18next';
import {
  DefaultRadioOptions,
  InsuranceJourneyHelperText,
  InsuranceSaveForLaterMessage,
  PageAbsolutePath,
  ValidationConstants,
  ValidationMessages
} from '../../../consts/Common';
import { ButtonCommand } from '../../common/Button/ButtonCommand';
import Claims from '../../common/Claims/Claims';
import ClickableHelpText from '../../common/HelpText/ClickableHelpText';
import useCarInsuranceController from '../../../hooks/insuranceJourney/useCarInsuranceController';
import {
  Gender,
  MaritalStatus,
  PagesWithDropdown,
  Title,
  WhoWillDrive
} from '../../common/Constants';
import LoadingContainer from '../../common/LoadingContainer/LoadingContainer';
import { useErrorBoundary } from 'react-error-boundary';

type AdditionalDriverDetailsErrors = {
  whoWillDrive: string;
  title: string;
  firstName: string;
  maritalStatus: string;
  dateOfBirth: string;
  gender: string;
  lastName: string;
  residentSinceBirth: string;
  residentSinceDate: string;
  additionalDriverRelationship: string;
  industry: string;
  occupation: string;
  licenceType: string;
  drivingConvictions: DrivingConvictionError[];
  medicalConditions: MedicalConditionError[];
  claims: ClaimError[];
  nonMotoringConvictions: string;
  declinedInsurance: string;
  yearsLicenceHeld: string;
  hadClaimAccidentLosses: string;
  hadMedicalConditionOrDisabilities: string;
  hadDrivingConvictions: string;
};

const initialFormErrors: AdditionalDriverDetailsErrors = {
  whoWillDrive: '',
  title: '',
  firstName: '',
  maritalStatus: '',
  dateOfBirth: '',
  gender: '',
  lastName: '',
  residentSinceBirth: '',
  residentSinceDate: '',
  additionalDriverRelationship: '',
  industry: '',
  occupation: '',
  licenceType: '',
  drivingConvictions: [],
  medicalConditions: [],
  claims: [],
  nonMotoringConvictions: '',
  declinedInsurance: '',
  yearsLicenceHeld: '',
  hadClaimAccidentLosses: '',
  hadMedicalConditionOrDisabilities: '',
  hadDrivingConvictions: ''
};

export const AdditionalDriverDetailsPage = (): JSX.Element => {
  const { site } = useContext(SiteContext);
  const token = site.user.token;
  const [showPopup, setShowPopup] = useState(false);
  const [showOtherFields, setShowOtherFields] = useState(false);
  const [modelHeaderText, setModelHeaderText] = useState('');
  const [modelBodyText, setModelBodyText] = useState('');
  const navigate = useNavigate();
  const { showBoundary } = useErrorBoundary();
  const { journey, pageEvents } = useOutletContext<InsuranceJourneyContext>();

  const [driverOptions, setDriverOptions] = useState<SelectOpt[]>([]);
  const [
    additionalDriverRelationshipOptions,
    setadditionalDriverRelationshipOptions
  ] = useState<SelectOpt[]>([]);
  const [titleOptions, setTitleOptions] = useState<SelectOpt[]>([]);
  const [genderOptions, setGenderOptions] = useState<SelectOpt[]>([]);
  const [maritalStatusOptions, setMaritalStatusOptions] = useState<SelectOpt[]>(
    []
  );
  const [occupationTypes, setOccupationTypes] = useState<DatalistOption[]>([]);

  const [industryTypes, setIndustryTypes] = useState<DatalistOption[]>([]);

  const [licenceTypeOptions, setLicenceTypeOptions] = useState<SelectOpt[]>([]);
  const [licenceHeldYearsOptions, setLicenceHeldYearsOptions] = useState<
    SelectOpt[]
  >([]);
  const [convictionTypeOptions, setConvictionTypeOptions] = useState<
    SelectOpt[]
  >([]);

  const [claimTypeOptions, setClaimTypeOptions] = useState<SelectOpt[]>([]);

  const [lengthOfBanTypeOptions, setLengthOfBanTypeOptions] = useState<
    SelectOpt[]
  >([]);

  const [medicalConditionTypeOptions, setMedicalConditionTypeOptions] =
    useState<DatalistOption[]>([]);

  const [formErrors, setFormErrors] =
    useState<AdditionalDriverDetailsErrors>(initialFormErrors);
  const [dobIsValid, setDobIsValid] = useState(true);
  const [updateDobError, setUpdateDobError] = useState(false);

  const {
    additionalDriverDetails,
    personalDetails,
    staticData,
    savingQuote,
    pageLoading
  } = journey;
  const { additionalDriverDetailsPage, commonEvents } = pageEvents;
  const { setSavingQuote, onPageChange, setStaticData, setPageLoading } =
    commonEvents;

  const {
    whoWillDrive,
    relationWithPolicyHolder,
    licenceType,
    firstName,
    lastName,
    title,
    dateOfBirth,
    gender,
    maritalStatus,
    residentSinceBirth,
    residentSinceDate,
    industry,
    industryKey,
    occupation,
    occupationKey,
    yearsLicenceHeld,
    declinedInsurance,
    nonMotoringConvictions,
    hadDrivingConvictions,
    drivingConvictions,
    hadMedicalConditionOrDisabilities,
    medicalConditions,
    hadClaimAccidentLosses,
    claims
  } = additionalDriverDetails;

  const {
    onChangeGenderSelection,
    onSelectChange,
    onChangeFirstName,
    onChangeLastName,
    onChangeDateOfBirth,
    onChangeOccupation,
    onChangeIndustry,
    onChangeResidentSinceBirth,
    onChangeResidentSinceDate,
    onUpdateDrivingConvictions,
    onUpdateMedicalConditions,
    onChangeHadMedicalConditionOrDisabilities,
    onChangeDeclinedInsurance,
    onChangeHadDrivingConvictions,
    onChangeNonMotoringConvictions,
    onChangeYearsLicenceHeld,
    onChangeHadClaimAccidentLosses,
    onUpdateClaims
  } = additionalDriverDetailsPage;

  const today = new Date();
  const { maxDob, minDob } = getInsuranceJourneyMinMaxDob();

  const { getAdditionalDriverPageDropdownValues } = useCarInsuranceController();

  const occupationErrorMessage =
    "Sorry, we couldn't find that occupation. Please re-check your spelling, or try a different job title which closely matches yours.";
  const industryErrorMessage =
    "Sorry, we couldn't find that industry. Please re-check your spelling, or try a different industry which closely matches yours.";
  const dobRequiredMsg = t('personal-details.dob-required-validation');
  const dobInvalidMsg = t('personal-details.dob-invalid-validation');
  const ageOutOfRange = 'Customer age must be between 17 to 90';
  const validationMessages = ValidationMessages.InsuranceJourney;
  const validationConstants = ValidationConstants.Insurance;

  const onBackendFailure = (err: string) => {
    showBoundary(new Error(err));
  };

  useEffect(() => {
    const titles = staticData?.find(
      (d) =>
        d.page === PagesWithDropdown.AdditionalDriverDetailsPage &&
        d.controlName === 'title'
    )?.values;

    const genders = staticData?.find(
      (d) =>
        d.page === PagesWithDropdown.AboutYouPage && d.controlName === 'genders'
    )?.values;

    const maritalStatusValues = staticData?.find(
      (d) =>
        d.page === PagesWithDropdown.AboutYouPage &&
        d.controlName === 'maritalStatus'
    )?.values;

    const whoWillDriveOptions = staticData?.find(
      (d) =>
        d.page === PagesWithDropdown.AdditionalDriverDetailsPage &&
        d.controlName === 'whoWillDrive'
    )?.values;

    const relationshipOptions = staticData?.find(
      (d) =>
        d.page === PagesWithDropdown.AdditionalDriverDetailsPage &&
        d.controlName === 'relationWithPolicyHolder'
    )?.values;

    titles ? setTitleOptions(titles) : setTitleOptions([]);
    genders ? setGenderOptions(genders) : setGenderOptions([]);
    maritalStatusValues
      ? setMaritalStatusOptions(maritalStatusValues)
      : setMaritalStatusOptions([]);
    whoWillDriveOptions
      ? setDriverOptions(whoWillDriveOptions)
      : setDriverOptions([]);
    relationshipOptions
      ? setadditionalDriverRelationshipOptions(relationshipOptions)
      : setadditionalDriverRelationshipOptions([]);
  }, [staticData]);

  useEffect(() => {
    if (title === Title.Mr) onChangeGenderSelection(Gender.Male);
    if (title === Title.Miss || title === Title.Mrs || title === Title.Ms)
      onChangeGenderSelection(Gender.Female);
  }, [title]);

  useEffect(() => {
    window.scrollTo(0, 0);

    const additionalDriverPageDropDownValues = staticData?.find(
      (d) => d.page === PagesWithDropdown.AdditionalDriverDetailsPage
    );

    !additionalDriverPageDropDownValues &&
      getAdditionalDriverPageDropdownValues(
        token,
        setAdditionalDriverDropDownlistSuccess,
        onBackendFailure
      );
    loadDrivingHistoryDropDownList();
  }, []);

  const setAdditionalDriverDropDownlistSuccess = (
    additionalDriverDropDownsList: AdditionalDriverDropDowns
  ) => {
    const newValues = [
      {
        page: PagesWithDropdown.AdditionalDriverDetailsPage,
        controlName: 'whoWillDrive',
        values: populateSelectOptions(additionalDriverDropDownsList.drivers)
      },
      {
        page: PagesWithDropdown.AdditionalDriverDetailsPage,
        controlName: 'title',
        values: populateSelectOptions(additionalDriverDropDownsList.titles)
      },
      {
        page: PagesWithDropdown.AdditionalDriverDetailsPage,
        controlName: 'relationWithPolicyHolder',
        values: populateSelectOptions(
          additionalDriverDropDownsList.additionalDriverRelationships
        )
      }
    ];

    setStaticData(staticData ? staticData.concat(...newValues) : newValues);
  };

  useEffect(() => {
    if (CommonValidation.isValidDate(dateOfBirth, false))
      loadLicenceYearsHeldDropDownList();
  }, [dateOfBirth]);

  useEffect(() => {
    validateAndShowInsusureOnlyPopup(whoWillDrive);
  }, [whoWillDrive]);

  useEffect(() => {
    validateAndShowPopup(licenceType);
  }, [licenceType]);

  const validateAndShowPopup = (value: string) => {
    if (value != null && value.includes('AUTO')) {
      setShowPopup(true);
      setModelBodyText(
        'We cannot guarantee an automatic car under our standard courtesy car cover'
      );
      setModelHeaderText("WE'RE SORRY");
    }
  };

  const validateAndShowInsusureOnlyPopup = (value: string) => {
    if (!SelectInputHelper.isNullValue(value)) {
      if (value === WhoWillDrive.InsuredOnly) {
        setShowPopup(true);
        setShowOtherFields(false);
        setModelBodyText(
          'Adding a second driver may reduce your annual policy quote, assuming both drivers have a similar driving history'
        );
        setModelHeaderText('PLEASE NOTE');
      } else if (
        (value === WhoWillDrive.InsuredAndSpouse ||
          value === WhoWillDrive.InsuredAndCivilPartner ||
          value === WhoWillDrive.InsuredAndPartnerSameAddress) &&
        (personalDetails.maritalStatus === MaritalStatus.Single ||
          personalDetails.maritalStatus == MaritalStatus.Separated ||
          personalDetails.maritalStatus == MaritalStatus.Widowed ||
          personalDetails.maritalStatus == MaritalStatus.Divorced)
      ) {
        setShowPopup(true);
        setShowOtherFields(false);
        const options = staticData.find(
          (d) =>
            d.page === PagesWithDropdown.AdditionalDriverDetailsPage &&
            d.controlName === 'whoWillDrive'
        );

        const text = options?.values.find((v) => v.value === value)?.text;

        setModelBodyText(
          `You have selected ${text} as drivers. Please check marital status of main driver is not single/separated/widowed/divorced before proceeding`
        );
        setModelHeaderText('Please check marital status of main driver');
      } else {
        if (site.user.isDealer) {
          setShowPopup(true);
          setShowOtherFields(false);
          setModelBodyText(
            'Who will drive? Add a second driver to Driveaway (minimum age of 25 applies)'
          );
          setModelHeaderText('PLEASE NOTE');
        }
        setShowOtherFields(true);
      }
    } else {
      setShowOtherFields(false);
    }
  };

  const setLicenceYearsHeldDropDownlistSuccess = (
    apiResponse: DrivingHistoryApiResponseModel
  ) => {
    setLicenceHeldYearsOptions(
      populateSelectOptions(apiResponse.licenceHeldYears)
    );
  };

  const loadLicenceYearsHeldDropDownList = async () => {
    const controller = new AbortController();

    await new CarInsuranceApi().GetDropDownValuesForDrivingHistoryAsync(
      dateOfBirth,
      token,
      setLicenceYearsHeldDropDownlistSuccess,
      onBackendFailure,
      controller.signal
    );

    return () => {
      controller.abort();
    };
  };

  const loadDrivingHistoryDropDownList = async () => {
    const controller = new AbortController();

    const setDrivingHistoryDropDownlistSuccess = (
      apiResponse: DrivingHistoryApiResponseModel
    ) => {
      setLicenceHeldYearsOptions(
        populateSelectOptions(apiResponse.licenceHeldYears)
      );
      setLicenceTypeOptions(populateSelectOptions(apiResponse.licenceTypes));
      setConvictionTypeOptions(
        populateSelectOptions(apiResponse.drivingConvictionTypes)
      );
      setLengthOfBanTypeOptions(
        populateSelectOptions(apiResponse.drivingBanLengths)
      );
      setMedicalConditionTypeOptions(
        populateDatalist(apiResponse.medicalConditions)
      );
      setClaimTypeOptions(populateSelectOptions(apiResponse.claimTypes));
    };

    await new CarInsuranceApi().GetDropDownValuesForDrivingHistoryAsync(
      dateOfBirth,
      token,
      setDrivingHistoryDropDownlistSuccess,
      onBackendFailure,
      controller.signal
    );

    return () => {
      controller.abort();
    };
  };

  const isAgeValid = (): boolean => {
    if (dateOfBirth === undefined) {
      return false;
    }

    let age = today.getFullYear() - dateOfBirth.getFullYear();
    const monthDiff = today.getMonth() - dateOfBirth.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < dateOfBirth.getDate())
    ) {
      age--;
    }

    const result = age >= 17 && age <= 90;
    return result;
  };

  const validateAdditionalDriverDetails = (): boolean => {
    let isValid = true;
    const updatedFormErrors = { ...initialFormErrors };

    if (!SelectInputHelper.isValidValue(whoWillDrive) || whoWillDrive == '') {
      isValid = false;
      updatedFormErrors.whoWillDrive = 'Driver is required';
    } else {
      if (whoWillDrive === WhoWillDrive.InsuredOnly) {
        return true;
      }
    }
    if (!SelectInputHelper.isValidValue(title) || title === '') {
      isValid = false;
      updatedFormErrors.title = 'Title is required';
    }
    if (CommonValidation.isEmpty(gender)) {
      isValid = false;
      updatedFormErrors.gender = 'Gender is required';
    }
    if (
      !SelectInputHelper.isValidValue(maritalStatus) ||
      maritalStatus === ''
    ) {
      isValid = false;
      updatedFormErrors.maritalStatus = 'Marital status is required';
    }

    if (CommonValidation.isEmpty(lastName)) {
      isValid = false;
      updatedFormErrors.lastName = validationMessages.lastNameRequiredMsg;
    } else if (lastName.length < validationConstants.lastNameMinCharLimit) {
      isValid = false;
      updatedFormErrors.lastName = validationMessages.lastNameLimitError;
    } else {
      if (isValidName(lastName)) updatedFormErrors.lastName = '';
      else {
        updatedFormErrors.lastName =
          ValidationMessages.InsuranceJourney.errorInvalidName;

        isValid = false;
      }
    }

    if (CommonValidation.isEmpty(firstName)) {
      isValid = false;
      updatedFormErrors.firstName = validationMessages.firstnameRequiredMsg;
    } else if (
      !CommonValidation.isValidLength(
        firstName,
        validationConstants.firstNameCharLimit
      )
    ) {
      isValid = false;
      updatedFormErrors.firstName = validationMessages.firstNameLimitError;
    } else {
      if (isValidName(firstName)) updatedFormErrors.firstName = '';
      else {
        updatedFormErrors.firstName =
          ValidationMessages.InsuranceJourney.errorInvalidName;

        isValid = false;
      }
    }

    if (SelectInputHelper.isNullValue(relationWithPolicyHolder)) {
      isValid = false;
      updatedFormErrors.additionalDriverRelationship = 'This field is required';
    }

    if (!residentSinceBirth && CommonValidation.isEmpty(residentSinceDate)) {
      isValid = false;
      updatedFormErrors.residentSinceDate = 'Resident since date is required';
    } else if (
      !residentSinceBirth &&
      !CommonValidation.isValidDate(residentSinceDate, false)
    ) {
      isValid = false;
      updatedFormErrors.residentSinceDate = 'Resident since date is invalid';
    }

    if (CommonValidation.isEmpty(occupationKey)) {
      updatedFormErrors.occupation = 'Occupation is required ';
      isValid = false;
    }

    if (CommonValidation.isEmpty(industryKey)) {
      updatedFormErrors.industry = 'Industry is required ';
      isValid = false;
    }

    if (SelectInputHelper.isNullValue(licenceType)) {
      updatedFormErrors.licenceType = 'Licence type is required';
      isValid = false;
    }

    if (
      CommonValidation.isEmpty(yearsLicenceHeld) ||
      yearsLicenceHeld == SelectInputHelper.NullValue()
    ) {
      updatedFormErrors.yearsLicenceHeld = 'No of years is required';
      isValid = false;
    }

    if (dobIsValid === false) {
      setUpdateDobError(true);
      isValid = false;
      formErrors.dateOfBirth = dobInvalidMsg;
    } else if (CommonValidation.isEmpty(dateOfBirth)) {
      setUpdateDobError(true);
      isValid = false;
      formErrors.dateOfBirth = dobRequiredMsg;
    } else if (isAgeValid() === false) {
      setUpdateDobError(true);
      isValid = false;
      formErrors.dateOfBirth = ageOutOfRange;
    }

    if (declinedInsurance === undefined || declinedInsurance === null) {
      updatedFormErrors.declinedInsurance = 'This field is required';
      isValid = false;
    }

    if (
      nonMotoringConvictions === undefined ||
      nonMotoringConvictions === null
    ) {
      updatedFormErrors.nonMotoringConvictions = 'This field is required';
      isValid = false;
    }

    if (
      hadClaimAccidentLosses === undefined ||
      hadClaimAccidentLosses === null
    ) {
      updatedFormErrors.hadClaimAccidentLosses = 'This field is required';
      isValid = false;
    }
    if (hadDrivingConvictions === undefined || hadDrivingConvictions === null) {
      updatedFormErrors.hadDrivingConvictions = 'This field is required';
      isValid = false;
    }

    if (hadClaimAccidentLosses === true) {
      if (claims.length === 0) {
        updatedFormErrors.claims = [
          {
            claimDate: 'Date is required',
            claimType: 'Claim type is required'
          }
        ];
        isValid = false;
      } else {
        updatedFormErrors.claims = claims.map((v) => {
          const e: ClaimError = {};
          if (CommonValidation.isEmpty(v.claimDate))
            e.claimDate = 'Date is required';
          if (
            SelectInputHelper.isNullValue(v.claimType) ||
            SelectInputHelper.isEmptyValue(v.claimType)
          )
            e.claimType = 'Claim type is required';
          return e;
        });

        if (
          updatedFormErrors.claims.filter(
            (e) =>
              CommonValidation.isNotEmpty(e.claimDate) ||
              CommonValidation.isNotEmpty(e.claimType)
          ).length > 0
        )
          isValid = false;
      }
    }

    if (hadDrivingConvictions) {
      updatedFormErrors.drivingConvictions = drivingConvictions.map((v) => {
        const e: DrivingConvictionError = {};

        if (CommonValidation.isEmpty(v.convictionDate))
          e.convictionDate = 'Date is required';

        if (
          SelectInputHelper.isNullValue(v.convictionType) ||
          SelectInputHelper.isEmptyValue(v.convictionType)
        )
          e.convictionTypes = 'Claim type is required';

        if (
          SelectInputHelper.isNullValue(v.lengthOfBan) ||
          SelectInputHelper.isEmptyValue(v.lengthOfBan)
        )
          e.lengthOfBan = 'Field is required';

        if (v.points === 0 || v.points === undefined)
          e.points = 'Field is required';

        return e;
      });

      if (
        updatedFormErrors.drivingConvictions.filter(
          (e) =>
            CommonValidation.isNotEmpty(e.convictionDate) ||
            CommonValidation.isNotEmpty(e.convictionTypes) ||
            CommonValidation.isNotEmpty(e.lengthOfBan) ||
            CommonValidation.isNotEmpty(e.points)
        ).length > 0
      )
        isValid = false;
    }

    if (
      hadMedicalConditionOrDisabilities === undefined ||
      hadMedicalConditionOrDisabilities === null
    ) {
      updatedFormErrors.hadMedicalConditionOrDisabilities =
        'This field is required';
      isValid = false;
    }

    if (hadMedicalConditionOrDisabilities === true) {
      if (medicalConditions.length === 0) {
        updatedFormErrors.medicalConditions = [
          {
            canKeepLicence: 'Field is required',
            hasDVLANotified: 'Field is required',
            typeOfCondition: 'Field is required'
          }
        ];
        isValid = false;
      } else {
        updatedFormErrors.medicalConditions = medicalConditions.map((v) => {
          const e: MedicalConditionError = {};

          if (CommonValidation.isEmpty(v.canKeepLicence))
            e.canKeepLicence = 'Field is required';

          if (CommonValidation.isEmpty(v.hasDVLANotified))
            e.hasDVLANotified = 'Field is required';

          if (CommonValidation.isEmpty(v.typeOfConditionKey))
            e.typeOfCondition = 'Field is required';

          return e;
        });

        if (
          updatedFormErrors.medicalConditions.filter(
            (e) =>
              CommonValidation.isNotEmpty(e.canKeepLicence) ||
              CommonValidation.isNotEmpty(e.hasDVLANotified) ||
              CommonValidation.isNotEmpty(e.typeOfCondition)
          ).length > 0
        )
          isValid = false;
      }
    }

    setFormErrors(updatedFormErrors);

    return isValid;
  };

  const handleOnLeaveOccupationField = (
    e: React.FormEvent<HTMLInputElement>
  ) => {
    getOccupationsBySearch(
      e.currentTarget.value,
      validateOccupationSuccess,
      onBackendFailure
    );
  };

  const handleOnLeaveIndustryField = (e: React.FormEvent<HTMLInputElement>) => {
    getIndustriesBySearch(
      e.currentTarget.value,
      validateIndustrySuccess,
      onBackendFailure
    );
  };

  const handleOccupationChange = (e: React.FormEvent<HTMLInputElement>) => {
    formErrors.occupation && setFormErrors({ ...formErrors, occupation: '' });
    const newOccupationKey = occupationTypes.find(
      (opt) => opt.text === e.currentTarget.value
    )?.value;

    onChangeOccupation(e.currentTarget.value, newOccupationKey);
    loadOccupationsBySearch(e.currentTarget.value);
  };

  const loadOccupationsBySearch = (value: string) => {
    if (value.length > 2)
      getOccupationsBySearch(value, setOccupationListSuccess, onBackendFailure);
    else setOccupationTypes(populateDatalist([]));
  };

  const validateOccupationSuccess = (occupations: KeyValuePair[]) => {
    const isValidOccupation =
      occupations.filter((o) => o.value === occupation).length > 0;

    if (isValidOccupation) setFormErrors({ ...formErrors, occupation: '' });
    else {
      setFormErrors({ ...formErrors, occupation: occupationErrorMessage });
      onChangeOccupation('');
      setOccupationTypes(populateDatalist([]));
    }
  };

  const validateIndustrySuccess = (industries: KeyValuePair[]) => {
    const isValidIndustry =
      industries.filter((i) => i.value === industry).length > 0;

    if (isValidIndustry) setFormErrors({ ...formErrors, industry: '' });
    else {
      setFormErrors({ ...formErrors, industry: industryErrorMessage });
      onChangeIndustry('');
      setIndustryTypes(populateDatalist([]));
    }
  };

  const setOccupationListSuccess = (occupations: KeyValuePair[]) => {
    setOccupationTypes(populateDatalist(occupations));
  };

  const getOccupationsBySearch = async (
    searchText: string,
    successFunction: (occupations: KeyValuePair[]) => void,
    failureFunction: (err: string) => void
  ) => {
    const controller = new AbortController();

    await new CarInsuranceApi().GetOccupationsBySearchAsync(
      searchText,
      token,
      successFunction,
      failureFunction,
      controller.signal
    );

    return () => {
      controller.abort();
    };
  };

  const handleOnModalContinueClick = () => {
    setShowPopup(false);
  };

  const handleIndustryChange = (e: React.FormEvent<HTMLInputElement>) => {
    formErrors.industry && setFormErrors({ ...formErrors, industry: '' });
    const newIndustryKey = industryTypes.find(
      (opt) => opt.text === e.currentTarget.value
    )?.value;
    onChangeIndustry(e.currentTarget.value, newIndustryKey);
    loadIndustriesBySearch(e.currentTarget.value);
  };

  const setIndustryListSuccess = (industries: KeyValuePair[]) => {
    setIndustryTypes(populateDatalist(industries));
  };

  const getIndustriesBySearch = async (
    searchText: string,
    successFunction: (industries: KeyValuePair[]) => void,
    failureFunction: (err: string) => void
  ) => {
    const controller = new AbortController();

    await new CarInsuranceApi().GetIndustriesBySearchAsync(
      searchText,
      token,
      successFunction,
      failureFunction,
      controller.signal
    );

    return () => {
      controller.abort();
    };
  };

  const loadIndustriesBySearch = (value: string) => {
    if (value.length > 2)
      getIndustriesBySearch(value, setIndustryListSuccess, onBackendFailure);
    else setIndustryTypes(populateDatalist([]));
  };

  const onDobValidated = (isValid: boolean): void => {
    setUpdateDobError(false);
    setDobIsValid(isValid);
  };

  const onToggleCheckbox = () => {
    onChangeResidentSinceBirth(!residentSinceBirth);
  };

  const onBackClick = () => {
    const path: string = setCountryCode(
      PageAbsolutePath.Insurance.AddressDetailsPage,
      site.countryCode
    );
    navigate(path);
  };

  const onNextClick = () => {
    const isValid = validateAdditionalDriverDetails();

    if (isValid) {
      const path: string = setCountryCode(
        PageAbsolutePath.Insurance.ConfirmationPage,
        site.countryCode
      );
      navigate(path);
      onPageChange(
        PageAbsolutePath.Insurance.AdditionalDriverDetailsPage,
        true
      );
    }
  };

  const onSaveLaterClick = (): void => {
    setPageLoading(true);
    setSavingQuote(true);
  };

  return (
    <LoadingContainer
      loading={pageLoading}
      message={InsuranceSaveForLaterMessage}>
      <>
        <div>
          <div className='one-col'>
            <ButtonCommand
              name='btn-back-top'
              text={'< Back'}
              onClick={onBackClick}
            />
          </div>
          <h4 className='section-header m1-top'>Additional Driver Details</h4>
          <div className='table-flex-layout'>
            <div className='form-container'>
              <div className='two-col'>
                <div className='control-label help-text'>
                  Who will drive?
                  <ClickableHelpText
                    helpText={
                      InsuranceJourneyHelperText.Pages.AdditionalDriverDetails
                        .WhoWillDrive
                    }
                  />
                </div>
                <div className='control'>
                  <SelectInput
                    name='whoWillDrive'
                    className='input-text w250'
                    value={whoWillDrive}
                    onChange={(value) => onSelectChange(value, 'whoWillDrive')}
                    options={driverOptions}
                    forceDefault
                    addDefaultOption
                    error={formErrors.whoWillDrive}
                  />
                </div>
              </div>
              {showOtherFields && (
                <>
                  <div className='two-col'>
                    <div className='control-label'>Title</div>
                    <div className='control'>
                      <SelectInput
                        name='title'
                        className='input-text w250'
                        value={title}
                        onChange={(value) => onSelectChange(value, 'title')}
                        options={titleOptions}
                        forceDefault
                        addDefaultOption
                        error={formErrors.title}
                      />
                    </div>
                  </div>
                  <div className='two-col'>
                    <div>
                      <div className='max-content'>
                        <GenderSelection
                          genderSelectionError={formErrors.gender}
                          selectedGender={gender}
                          genderList={genderOptions}
                          setSelectedGender={onChangeGenderSelection}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='two-col'>
                    <div className='control-label'>First Name</div>
                    <div className='control'>
                      <TextInput
                        placeholder='First Name'
                        name='firstName'
                        className='input-text w250'
                        value={firstName}
                        onChange={(e: React.FormEvent<HTMLInputElement>) =>
                          onChangeFirstName(e)
                        }
                        error={formErrors.firstName}
                        readOnly={false}
                      />
                    </div>
                  </div>
                  <div className='two-col'>
                    <div className='control-label'>Last Name</div>
                    <div className='control'>
                      <TextInput
                        placeholder='Last Name'
                        name='lastName'
                        className='input-text w250'
                        value={lastName}
                        onChange={onChangeLastName}
                        error={formErrors.lastName}
                        readOnly={false}
                      />
                    </div>
                  </div>
                  <div className='two-col'>
                    <div className='control-label'>Marital Status</div>
                    <div className='control'>
                      <SelectInput
                        name='maritalStatus'
                        className='input-text w250'
                        value={maritalStatus}
                        onChange={(value) =>
                          onSelectChange(value, 'maritalStatus')
                        }
                        options={maritalStatusOptions}
                        forceDefault
                        addDefaultOption
                        error={formErrors.maritalStatus}
                      />
                    </div>
                  </div>
                  <div className='two-col'>
                    <div className='control-label'>
                      Relationship to the main policy holder
                    </div>
                    <div className='control'>
                      <SelectInput
                        name='relationWithPolicyHolder'
                        className='input-text w250'
                        value={relationWithPolicyHolder}
                        onChange={(value) =>
                          onSelectChange(value, 'relationWithPolicyHolder')
                        }
                        options={additionalDriverRelationshipOptions}
                        forceDefault
                        addDefaultOption
                        error={formErrors.additionalDriverRelationship}
                      />
                    </div>
                  </div>

                  <div className='two-col'>
                    <div className='control-label'>Date of birth</div>
                    <div className='control'>
                      <DateSelector
                        value={dateOfBirth}
                        minDate={minDob}
                        maxDate={maxDob}
                        invalidDateMessage={formErrors.dateOfBirth}
                        updateDobError={updateDobError}
                        culture={site.cultureCode}
                        onChange={(value) => onChangeDateOfBirth(value)}
                        onValidated={(isValid) => onDobValidated(isValid)}
                        name={'dob'}
                      />
                    </div>
                  </div>
                  <div className='two-col'>
                    <div className='control-label'>
                      How Long Have You Been Resident In The UK?
                    </div>
                    <div className='control'>
                      <Checkbox
                        id='resident-since-birth'
                        checked={residentSinceBirth}
                        text={'Since birth'}
                        onChange={onToggleCheckbox}
                        disabled={false}
                      />
                      <div style={{ paddingTop: '10px', paddingBottom: '3px' }}>
                        or since
                      </div>
                      <DateSelector
                        value={residentSinceDate}
                        minDate={minDob}
                        maxDate={today}
                        invalidDateMessage={formErrors.residentSinceDate}
                        updateDobError={false}
                        culture={site.cultureCode}
                        hideDay={true}
                        disabled={residentSinceBirth}
                        onChange={(value) => onChangeResidentSinceDate(value)}
                        onValidated={() => {}}
                        name={'resident-since'}
                      />
                    </div>
                  </div>
                  <div className='two-col'>
                    <div className='control-label'>Licence Type</div>
                    <div className='control'>
                      <SelectInput
                        name='licenceType'
                        className='input-text w250'
                        value={licenceType}
                        onChange={(value) =>
                          onSelectChange(value, 'licenceType')
                        }
                        options={licenceTypeOptions}
                        forceDefault
                        addDefaultOption
                        error={formErrors.licenceType}
                      />
                    </div>
                  </div>
                  <div className='two-col'>
                    <div className='control-label'>{'Years licence held'}</div>
                    <div className='control'>
                      <Tooltip
                        title={
                          'Please select Date of birth to calculate licence years'
                        }
                        enterTouchDelay={0}
                        arrow>
                        <SelectInput
                          name='years-licence-held'
                          className='input-text w250'
                          value={yearsLicenceHeld}
                          onChange={onChangeYearsLicenceHeld}
                          options={licenceHeldYearsOptions}
                          defaultText={t('personal-details.title-default')}
                          forceDefault
                          addDefaultOption
                          loadingText={t('loading-placeholder.loading-text')}
                          error={formErrors.yearsLicenceHeld}
                        />
                      </Tooltip>
                    </div>
                  </div>
                  <div className='two-col'>
                    <div className='control-label'>What's Your Occupation?</div>
                    <h6>
                      Start typing the first three letters of your job title
                      then select from the list. If you can't find your exact
                      title please choose whichever is closest
                    </h6>
                    <div className='control'>
                      <SearchTextInput
                        name='occupation'
                        className='input-text w250'
                        value={occupation}
                        onChange={handleOccupationChange}
                        onLeave={handleOnLeaveOccupationField}
                        readOnly={false}
                        listName='occupationList'
                        listData={occupationTypes}
                        error={formErrors.occupation}
                      />
                    </div>
                  </div>
                  <div className='two-col'>
                    <div className='control-label'>
                      Which Industry Do You Work In?
                    </div>
                    <h6>
                      Start typing the first three letters of the industry you
                      work in then select from the list. If you can't find the
                      exact one, please choose whichever is closest
                    </h6>
                    <div className='control'>
                      <SearchTextInput
                        name='industry'
                        className='input-text w250'
                        value={industry}
                        onChange={handleIndustryChange}
                        onLeave={handleOnLeaveIndustryField}
                        readOnly={false}
                        listName='industryList'
                        listData={industryTypes}
                        error={formErrors.industry}
                      />
                    </div>
                  </div>
                  <div className='one-col'>
                    <RadioSelection
                      show={true}
                      error={formErrors.hadClaimAccidentLosses}
                      selectionName={
                        'Have they had any claims/accidents/losses in the last 5 years?'
                      }
                      fontDisabledClass=''>
                      {renderRadioOptions(
                        DefaultRadioOptions,
                        'hadClaimAccidentLosses',
                        hadClaimAccidentLosses === null
                          ? ''
                          : hadClaimAccidentLosses
                            ? 'Yes'
                            : 'No',
                        (value) =>
                          onChangeHadClaimAccidentLosses(value === 'Yes')
                      )}
                    </RadioSelection>
                  </div>
                  {hadClaimAccidentLosses && (
                    <Claims
                      claims={claims}
                      claimTypes={claimTypeOptions}
                      onUpdateClaims={onUpdateClaims}
                      errors={formErrors.claims}
                    />
                  )}
                  <div className='one-col'>
                    <RadioOptions
                      errorMessage={formErrors.hadDrivingConvictions}
                      label='Have they had any driving convictions, including fixed penalty notices, in the last five years?'
                      name='driving-convictions'
                      optionsList={DefaultRadioOptions}
                      selectedOption={
                        hadDrivingConvictions === null
                          ? ''
                          : hadDrivingConvictions
                            ? 'Yes'
                            : 'No'
                      }
                      setSelectedOption={(value) =>
                        onChangeHadDrivingConvictions(value === 'Yes')
                      }
                    />
                  </div>
                  {hadDrivingConvictions && (
                    <DrivingConvictions
                      convictionTypes={convictionTypeOptions}
                      lengthOfBanTypes={lengthOfBanTypeOptions}
                      drivingConvictions={drivingConvictions}
                      errorMessages={formErrors.drivingConvictions}
                      onUpdateDrivingConvictions={onUpdateDrivingConvictions}
                    />
                  )}
                  <div className='one-col'>
                    <div className='control-label help-text'>
                      {'Do you have any non motoring convictions?'}

                      <ClickableHelpText
                        helpText={
                          InsuranceJourneyHelperText.Pages
                            .AdditionalDriverDetails.NonMotoringConvictions
                        }
                      />
                    </div>
                    <RadioOptions
                      errorMessage={formErrors.nonMotoringConvictions}
                      label=''
                      name='non-motoring-convictions'
                      optionsList={DefaultRadioOptions}
                      selectedOption={
                        nonMotoringConvictions === null
                          ? ''
                          : nonMotoringConvictions
                            ? 'Yes'
                            : 'No'
                      }
                      setSelectedOption={(value) =>
                        onChangeNonMotoringConvictions(value === 'Yes')
                      }
                    />
                  </div>
                  <div className='one-col'>
                    <div className='control-label help-text'>
                      {
                        'Have you had any medical conditions or disabilities that are DVLA reportable?'
                      }
                      <ClickableHelpText
                        helpText={
                          InsuranceJourneyHelperText.Pages
                            .AdditionalDriverDetails.Medicalconditions
                        }
                      />
                    </div>
                    <RadioSelection
                      show={true}
                      error={formErrors.hadMedicalConditionOrDisabilities}
                      selectionName=''
                      fontDisabledClass=''>
                      {renderRadioOptions(
                        DefaultRadioOptions,
                        'hadMedicalConditionOrDisabilities',
                        hadMedicalConditionOrDisabilities === null
                          ? ''
                          : hadMedicalConditionOrDisabilities
                            ? 'Yes'
                            : 'No',
                        (value) =>
                          onChangeHadMedicalConditionOrDisabilities(
                            value === 'Yes'
                          )
                      )}
                    </RadioSelection>
                  </div>
                  {hadMedicalConditionOrDisabilities && (
                    <MedicalConditions
                      medicalConditionTypes={medicalConditionTypeOptions}
                      medicalConditions={medicalConditions}
                      errorMessages={formErrors.medicalConditions}
                      onUpdateMedicalConditions={onUpdateMedicalConditions}
                      brand={site.brand.brandName}
                    />
                  )}
                  <div className='one-col'>
                    <div className='control-label help-text'>
                      {
                        'Have you ever had an insurance policy declined, cancelled, voided or had special terms imposed?'
                      }
                      <ClickableHelpText
                        helpText={
                          InsuranceJourneyHelperText.Pages
                            .AdditionalDriverDetails.InsuranceDeclined
                        }
                      />
                    </div>
                    <RadioOptions
                      errorMessage={formErrors.declinedInsurance}
                      label=''
                      name='declined-insurance'
                      optionsList={DefaultRadioOptions}
                      selectedOption={
                        declinedInsurance === null
                          ? ''
                          : declinedInsurance === true
                            ? 'Yes'
                            : 'No'
                      }
                      setSelectedOption={(value) =>
                        onChangeDeclinedInsurance(value === 'Yes')
                      }
                    />
                  </div>
                </>
              )}
            </div>
          </div>
          <div className='flex-row form-nav'>
            <ButtonBack
              name='btn-back'
              text='Back'
              onClick={onBackClick}
              additionalClassNames='btn-back'
            />
            <ButtonContinue
              name='btn-save-later'
              text='Save For Later'
              onClick={onSaveLaterClick}
              additionalClassNames='btn-save'
              disabled={savingQuote}
            />
            <ButtonContinue
              name='btn-next'
              text='Next'
              onClick={onNextClick}
              additionalClassNames='btn-continue'
            />
          </div>
        </div>
        <Modal
          role='modal-popup'
          isOpen={showPopup}
          className={`insurance-${site.brand.brandName}`}
          toggle={() => setShowPopup(false)}>
          <ModalHeader toggle={() => setShowPopup(false)}>
            {modelHeaderText}
          </ModalHeader>
          <ModalBody>{modelBodyText}</ModalBody>
          <ModalFooter>
            <ButtonContinue
              name='modal-btn-continue'
              text='Continue'
              onClick={handleOnModalContinueClick}
              additionalClassNames='btn-ok'
            />
          </ModalFooter>
        </Modal>
      </>
    </LoadingContainer>
  );
};

export default AdditionalDriverDetailsPage;
